export interface iPaisesCodigo {
  id: number,
  nombre: string,
  iso2: string,
  iso3: string,
  iso: string
}

export const paisesCodigo: iPaisesCodigo[] = [
    { "id": 4, "nombre": "AFGANISTAN", "iso2": "AF", "iso3": "", "iso": "" },
    { "id": 8, "nombre": "ALBANIA", "iso2": "AL", "iso3": "", "iso": "" },
    { "id": 10, "nombre": "ANTARTIDA", "iso2": "AQ", "iso3": "", "iso": "" },
    { "id": 12, "nombre": "ARGELIA", "iso2": "DZ", "iso3": "", "iso": "" },
    { "id": 16, "nombre": "SAMOA AMERICANA", "iso2": "AS", "iso3": "", "iso": "" },
    { "id": 20, "nombre": "ANDORRA", "iso2": "AD", "iso3": "*", "iso": "" },
    { "id": 24, "nombre": "ANGOLA", "iso2": "AO", "iso3": "", "iso": "" },
    { "id": 28, "nombre": "ANTIGUA Y BARBUDA", "iso2": "AG", "iso3": "*", "iso": "" },
    { "id": 31, "nombre": "AZERBAYAN", "iso2": "AZ", "iso3": "", "iso": "" },
    { "id": 32, "nombre": "ARGENTINA", "iso2": "AR", "iso3": "", "iso": "" },
    { "id": 36, "nombre": "AUSTRALIA", "iso2": "AU", "iso3": "", "iso": "" },
    { "id": 40, "nombre": "AUSTRIA", "iso2": "AT", "iso3": "", "iso": "*" },
    { "id": 44, "nombre": "BAHAMAS", "iso2": "BS", "iso3": "*", "iso": "" },
    { "id": 48, "nombre": "BAHREIN", "iso2": "BH", "iso3": "*", "iso": "" },
    { "id": 50, "nombre": "BANGLADESH", "iso2": "BD", "iso3": "", "iso": "" },
    { "id": 51, "nombre": "ARMENIA", "iso2": "AM", "iso3": "", "iso": "" },
    { "id": 52, "nombre": "BARBADOS", "iso2": "BB", "iso3": "*", "iso": "" },
    { "id": 56, "nombre": "BELGICA", "iso2": "BE", "iso3": "", "iso": "*" },
    { "id": 60, "nombre": "BERMUDAS", "iso2": "BM", "iso3": "*", "iso": "" },
    { "id": 64, "nombre": "BUTAN", "iso2": "BT", "iso3": "", "iso": "" },
    { "id": 68, "nombre": "BOLIVIA", "iso2": "BO", "iso3": "", "iso": "" },
    { "id": 70, "nombre": "BOSNIA-HERZEGOVINA", "iso2": "BA", "iso3": "", "iso": "" },
    { "id": 72, "nombre": "BOTSWANA", "iso2": "BW", "iso3": "", "iso": "" },
    { "id": 74, "nombre": "BOUVET ISLA", "iso2": "BV", "iso3": "", "iso": "" },
    { "id": 76, "nombre": "BRASIL", "iso2": "BR", "iso3": "", "iso": "" },
    { "id": 84, "nombre": "BELICE", "iso2": "BZ", "iso3": "", "iso": "" },
    { "id": 86, "nombre": "OCEANO INDICO TERRIT. BRITAN.", "iso2": "IO", "iso3": "", "iso": "" },
    { "id": 90, "nombre": "SALOMON ISLAS", "iso2": "SB", "iso3": "*", "iso": "" },
    { "id": 92, "nombre": "VIRGENES (BRITANICAS) ISLAS", "iso2": "VG", "iso3": "*", "iso": "" },
    { "id": 96, "nombre": "BRUNEI DARUSSALAM", "iso2": "BN", "iso3": "*", "iso": "" },
    { "id": 100, "nombre": "BULGARIA", "iso2": "BG", "iso3": "", "iso": "*" },
    { "id": 104, "nombre": "MYANMAR", "iso2": "MM", "iso3": "", "iso": "" },
    { "id": 108, "nombre": "BURUNDI", "iso2": "BI", "iso3": "", "iso": "" },
    { "id": 112, "nombre": "BIELORRUSIA", "iso2": "BY", "iso3": "", "iso": "" },
    { "id": 116, "nombre": "CAMBOYA", "iso2": "KH", "iso3": "", "iso": "" },
    { "id": 120, "nombre": "CAMERUN", "iso2": "CM", "iso3": "", "iso": "" },
    { "id": 124, "nombre": "CANADA", "iso2": "CA", "iso3": "", "iso": "" },
    { "id": 132, "nombre": "CABO VERDE", "iso2": "CV", "iso3": "", "iso": "" },
    { "id": 136, "nombre": "CAIMANES ISLAS", "iso2": "KY", "iso3": "*", "iso": "" },
    { "id": 140, "nombre": "CENTROAFRICANA REPUBLICA", "iso2": "CF", "iso3": "", "iso": "" },
    { "id": 144, "nombre": "SRI LANKA", "iso2": "LK", "iso3": "", "iso": "" },
    { "id": 148, "nombre": "CHAD", "iso2": "TD", "iso3": "", "iso": "" },
    { "id": 152, "nombre": "CHILE", "iso2": "CL", "iso3": "", "iso": "" },
    { "id": 156, "nombre": "CHINA", "iso2": "CN", "iso3": "", "iso": "" },
    { "id": 158, "nombre": "TAIWAN PROVINCIA DE CHINA", "iso2": "TW", "iso3": "", "iso": "" },
    { "id": 162, "nombre": "ISLA NAVIDAD", "iso2": "CX", "iso3": "", "iso": "" },
    { "id": 166, "nombre": "COCOS (KEELING) ISLAS", "iso2": "CC", "iso3": "", "iso": "" },
    { "id": 170, "nombre": "COLOMBIA", "iso2": "CO", "iso3": "", "iso": "" },
    { "id": 174, "nombre": "COMORES", "iso2": "KM", "iso3": "", "iso": "" },
    { "id": 175, "nombre": "MAYOTTE", "iso2": "YT", "iso3": "", "iso": "" },
    { "id": 178, "nombre": "CONGO", "iso2": "CG", "iso3": "", "iso": "" },
    { "id": 180, "nombre": "REPUBLICA DEMOCRATICA DEL CONG", "iso2": "CD", "iso3": "", "iso": "" },
    { "id": 184, "nombre": "COOK ISLAS", "iso2": "CK", "iso3": "*", "iso": "" },
    { "id": 188, "nombre": "COSTA RICA", "iso2": "CR", "iso3": "", "iso": "" },
    { "id": 191, "nombre": "CROACIA", "iso2": "HR", "iso3": "", "iso": "" },
    { "id": 192, "nombre": "CUBA", "iso2": "CU", "iso3": "", "iso": "" },
    { "id": 196, "nombre": "CHIPRE", "iso2": "CY", "iso3": "*", "iso": "*" },
    { "id": 203, "nombre": "REPUBLICA CHECA", "iso2": "CZ", "iso3": "", "iso": "*" },
    { "id": 204, "nombre": "BENIN", "iso2": "BJ", "iso3": "", "iso": "" },
    { "id": 208, "nombre": "DINAMARCA", "iso2": "DK", "iso3": "", "iso": "*" },
    { "id": 212, "nombre": "DOMINICA", "iso2": "DM", "iso3": "*", "iso": "" },
    { "id": 214, "nombre": "DOMINICANA REPUBLICA", "iso2": "DO", "iso3": "", "iso": "" },
    { "id": 218, "nombre": "ECUADOR", "iso2": "EC", "iso3": "", "iso": "" },
    { "id": 222, "nombre": "EL SALVADOR", "iso2": "SV", "iso3": "", "iso": "" },
    { "id": 226, "nombre": "GUINEA ECUATORIAL", "iso2": "GQ", "iso3": "", "iso": "" },
    { "id": 231, "nombre": "ETIOPIA", "iso2": "ET", "iso3": "", "iso": "" },
    { "id": 232, "nombre": "ERITREA", "iso2": "ER", "iso3": "", "iso": "" },
    { "id": 233, "nombre": "ESTONIA", "iso2": "EE", "iso3": "", "iso": "*" },
    { "id": 234, "nombre": "FEROE ISLAS", "iso2": "FO", "iso3": "", "iso": "" },
    { "id": 238, "nombre": "FALKLAND ISLAS (MALVINAS)", "iso2": "FK", "iso3": "*", "iso": "" },
    { "id": 239, "nombre": "GEORGIA DEL SUR E ISLAS SANDW.", "iso2": "GS", "iso3": "", "iso": "" },
    { "id": 242, "nombre": "FIDJI", "iso2": "FJ", "iso3": "*", "iso": "" },
    { "id": 246, "nombre": "FINLANDIA", "iso2": "FI", "iso3": "", "iso": "*" },
    { "id": 249, "nombre": "FRANCIA METROPOLITANA", "iso2": "FR", "iso3": "", "iso": "" },
    { "id": 250, "nombre": "FRANCIA", "iso2": "FR", "iso3": "", "iso": "*" },
    { "id": 254, "nombre": "GUAYANA FRANCESA", "iso2": "FR", "iso3": "", "iso": "" },
    { "id": 258, "nombre": "POLINESIA FRANCESA", "iso2": "FR", "iso3": "", "iso": "" },
    { "id": 260, "nombre": "TIERRAS AUSTRALES FRANCESAS", "iso2": "TF", "iso3": "", "iso": "" },
    { "id": 262, "nombre": "DJIBUTI", "iso2": "DJ", "iso3": "", "iso": "" },
    { "id": 266, "nombre": "GABON", "iso2": "GA", "iso3": "", "iso": "" },
    { "id": 268, "nombre": "GEORGIA", "iso2": "GE", "iso3": "", "iso": "" },
    { "id": 270, "nombre": "GAMBIA", "iso2": "GM", "iso3": "", "iso": "" },
    { "id": 276, "nombre": "ALEMANIA", "iso2": "DE", "iso3": "", "iso": "*" },
    { "id": 288, "nombre": "GHANA", "iso2": "GH", "iso3": "", "iso": "" },
    { "id": 292, "nombre": "GIBRALTAR", "iso2": "GI", "iso3": "*", "iso": "" },
    { "id": 296, "nombre": "KIRIBATI", "iso2": "KI", "iso3": "", "iso": "" },
    { "id": 300, "nombre": "GRECIA", "iso2": "EL", "iso3": "", "iso": "*" },
    { "id": 304, "nombre": "GROENLANDIA", "iso2": "GL", "iso3": "", "iso": "" },
    { "id": 308, "nombre": "GRANADA", "iso2": "GD", "iso3": "*", "iso": "" },
    { "id": 312, "nombre": "GUADALUPE", "iso2": "FR", "iso3": "", "iso": "" },
    { "id": 316, "nombre": "GUAM", "iso2": "GU", "iso3": "", "iso": "" },
    { "id": 320, "nombre": "GUATEMALA", "iso2": "GT", "iso3": "", "iso": "" },
    { "id": 324, "nombre": "GUINEA", "iso2": "GN", "iso3": "", "iso": "" },
    { "id": 328, "nombre": "GUAYANA", "iso2": "GY", "iso3": "", "iso": "" },
    { "id": 332, "nombre": "HAITI", "iso2": "HT", "iso3": "", "iso": "" },
    { "id": 334, "nombre": "HEARD Y MC DONALD ISLAS", "iso2": "HM", "iso3": "", "iso": "" },
    { "id": 336, "nombre": "VATICANO EST.DE LA CIUDAD DEL", "iso2": "VA", "iso3": "", "iso": "" },
    { "id": 340, "nombre": "HONDURAS", "iso2": "HN", "iso3": "", "iso": "" },
    { "id": 344, "nombre": "HONG KONG", "iso2": "HK", "iso3": "*", "iso": "" },
    { "id": 348, "nombre": "HUNGRIA", "iso2": "HU", "iso3": "", "iso": "*" },
    { "id": 352, "nombre": "ISLANDIA", "iso2": "IS", "iso3": "", "iso": "" },
    { "id": 356, "nombre": "INDIA", "iso2": "IN", "iso3": "", "iso": "" },
    { "id": 360, "nombre": "INDONESIA", "iso2": "ID", "iso3": "", "iso": "" },
    { "id": 364, "nombre": "IRAN (REPUBLICA ISLAMICA DE)", "iso2": "IR", "iso3": "", "iso": "" },
    { "id": 368, "nombre": "IRAQ", "iso2": "IQ", "iso3": "", "iso": "" },
    { "id": 372, "nombre": "IRLANDA", "iso2": "IE", "iso3": "", "iso": "*" },
    { "id": 376, "nombre": "ISRAEL", "iso2": "IL", "iso3": "", "iso": "" },
    { "id": 380, "nombre": "ITALIA", "iso2": "IT", "iso3": "", "iso": "*" },
    { "id": 384, "nombre": "COSTA DE MARFIL", "iso2": "CI", "iso3": "", "iso": "" },
    { "id": 388, "nombre": "JAMAICA", "iso2": "JM", "iso3": "*", "iso": "" },
    { "id": 392, "nombre": "JAPON", "iso2": "JP", "iso3": "", "iso": "" },
    { "id": 398, "nombre": "KAZAKSTAN", "iso2": "KZ", "iso3": "", "iso": "" },
    { "id": 400, "nombre": "JORDANIA", "iso2": "JO", "iso3": "*", "iso": "" },
    { "id": 404, "nombre": "KENIA", "iso2": "KE", "iso3": "", "iso": "" },
    { "id": 408, "nombre": "COREA REPUBLICA POPULAR DEM.", "iso2": "KP", "iso3": "", "iso": "" },
    { "id": 410, "nombre": "COREA REPUBLICA DE", "iso2": "KR", "iso3": "", "iso": "" },
    { "id": 414, "nombre": "KUWAIT", "iso2": "KW", "iso3": "", "iso": "" },
    { "id": 417, "nombre": "KIRGHIZISTAN", "iso2": "KG", "iso3": "", "iso": "" },
    { "id": 418, "nombre": "LAOS REPUBLICA DEM. POPULAR", "iso2": "LA", "iso3": "", "iso": "" },
    { "id": 422, "nombre": "LIBANO", "iso2": "LB", "iso3": "*", "iso": "" },
    { "id": 426, "nombre": "LESOTHO", "iso2": "LS", "iso3": "", "iso": "" },
    { "id": 428, "nombre": "LETONIA", "iso2": "LV", "iso3": "", "iso": "*" },
    { "id": 430, "nombre": "LIBERIA", "iso2": "LR", "iso3": "*", "iso": "" },
    { "id": 434, "nombre": "LIBIA JAMAHIRIYA ARABE", "iso2": "LY", "iso3": "", "iso": "" },
    { "id": 438, "nombre": "LIECHTENSTEIN", "iso2": "LI", "iso3": "*", "iso": "" },
    { "id": 440, "nombre": "LITUANIA", "iso2": "LT", "iso3": "", "iso": "*" },
    { "id": 442, "nombre": "LUXEMBURGO", "iso2": "LU", "iso3": "", "iso": "*" },
    { "id": 446, "nombre": "MACAO", "iso2": "MO", "iso3": "*", "iso": "" },
    { "id": 450, "nombre": "MADAGASCAR", "iso2": "MG", "iso3": "", "iso": "" },
    { "id": 454, "nombre": "MALAWI", "iso2": "MW", "iso3": "", "iso": "" },
    { "id": 458, "nombre": "MALASIA", "iso2": "MY", "iso3": "", "iso": "" },
    { "id": 462, "nombre": "MALDIVAS", "iso2": "MV", "iso3": "", "iso": "" },
    { "id": 466, "nombre": "MALI", "iso2": "ML", "iso3": "", "iso": "" },
    { "id": 470, "nombre": "MALTA", "iso2": "MT", "iso3": "*", "iso": "*" },
    { "id": 474, "nombre": "MARTINICA", "iso2": "FR", "iso3": "", "iso": "" },
    { "id": 478, "nombre": "MAURITANIA", "iso2": "MR", "iso3": "", "iso": "" },
    { "id": 480, "nombre": "MAURICIO", "iso2": "MU", "iso3": "*", "iso": "" },
    { "id": 484, "nombre": "MEJICO", "iso2": "MX", "iso3": "", "iso": "" },
    { "id": 492, "nombre": "MONACO", "iso2": "MC", "iso3": "*", "iso": "" },
    { "id": 496, "nombre": "MONGOLIA", "iso2": "MN", "iso3": "", "iso": "" },
    { "id": 498, "nombre": "MOLDAVIA REPUBLICA DE", "iso2": "MD", "iso3": "", "iso": "" },
    { "id": 500, "nombre": "MONTSERRAT", "iso2": "MS", "iso3": "*", "iso": "" },
    { "id": 504, "nombre": "MARRUECOS", "iso2": "MA", "iso3": "", "iso": "" },
    { "id": 508, "nombre": "MOZAMBIQUE", "iso2": "MZ", "iso3": "", "iso": "" },
    { "id": 512, "nombre": "OMAN", "iso2": "OM", "iso3": "*", "iso": "" },
    { "id": 516, "nombre": "NAMIBIA", "iso2": "NA", "iso3": "", "iso": "" },
    { "id": 520, "nombre": "NAURU", "iso2": "NR", "iso3": "*", "iso": "" },
    { "id": 524, "nombre": "NEPAL", "iso2": "NP", "iso3": "", "iso": "" },
    { "id": 528, "nombre": "HOLANDA", "iso2": "NL", "iso3": "", "iso": "*" },
    { "id": 532, "nombre": "ANTILLAS NEERLANDESAS", "iso2": "AN", "iso3": "*", "iso": "" },
    { "id": 533, "nombre": "ARUBA", "iso2": "AW", "iso3": "*", "iso": "" },
    { "id": 540, "nombre": "NUEVA CALEDONIA", "iso2": "NC", "iso3": "", "iso": "" },
    { "id": 548, "nombre": "VANUATU", "iso2": "VU", "iso3": "*", "iso": "" },
    { "id": 554, "nombre": "NUEVA ZELANDA", "iso2": "NZ", "iso3": "", "iso": "" },
    { "id": 558, "nombre": "NICARAGUA", "iso2": "NI", "iso3": "", "iso": "" },
    { "id": 562, "nombre": "NIGER", "iso2": "NE", "iso3": "", "iso": "" },
    { "id": 566, "nombre": "NIGERIA", "iso2": "NG", "iso3": "", "iso": "" },
    { "id": 570, "nombre": "NIUE", "iso2": "NU", "iso3": "", "iso": "" },
    { "id": 574, "nombre": "NORFOLK ISLA", "iso2": "NF", "iso3": "", "iso": "" },
    { "id": 578, "nombre": "NORUEGA", "iso2": "NO", "iso3": "", "iso": "" },
    { "id": 580, "nombre": "MARIANAS DEL NORTE ISLAS", "iso2": "MP", "iso3": "*", "iso": "" },
    { "id": 581, "nombre": "ISLAS MENORES ALEJADAS E.E.U.U", "iso2": "**", "iso3": "", "iso": "" },
    { "id": 583, "nombre": "MICRONESIA", "iso2": "FM", "iso3": "", "iso": "" },
    { "id": 584, "nombre": "MARSHALL ISLAS", "iso2": "MH", "iso3": "", "iso": "" },
    { "id": 585, "nombre": "PALAU", "iso2": "PW", "iso3": "", "iso": "" },
    { "id": 586, "nombre": "PAKISTAN", "iso2": "PK", "iso3": "", "iso": "" },
    { "id": 591, "nombre": "PANAMA", "iso2": "PA", "iso3": "*", "iso": "" },
    { "id": 598, "nombre": "PAPUA NUEVA GUINEA", "iso2": "PG", "iso3": "", "iso": "" },
    { "id": 600, "nombre": "PARAGUAY", "iso2": "PY", "iso3": "", "iso": "" },
    { "id": 604, "nombre": "PERU", "iso2": "PE", "iso3": "", "iso": "" },
    { "id": 608, "nombre": "FILIPINAS", "iso2": "PH", "iso3": "", "iso": "" },
    { "id": 612, "nombre": "PITCAIRN", "iso2": "PN", "iso3": "", "iso": "" },
    { "id": 616, "nombre": "POLONIA", "iso2": "PL", "iso3": "", "iso": "*" },
    { "id": 620, "nombre": "PORTUGAL", "iso2": "PT", "iso3": "", "iso": "*" },
    { "id": 624, "nombre": "GUINEA BISSAU", "iso2": "GW", "iso3": "", "iso": "" },
    { "id": 626, "nombre": "TIMOR LESTE", "iso2": "TL", "iso3": "", "iso": "" },
    { "id": 630, "nombre": "PUERTO RICO", "iso2": "**", "iso3": "", "iso": "" },
    { "id": 634, "nombre": "QATAR", "iso2": "QA", "iso3": "", "iso": "" },
    { "id": 638, "nombre": "REUNION", "iso2": "FR", "iso3": "", "iso": "" },
    { "id": 642, "nombre": "RUMANIA", "iso2": "RO", "iso3": "", "iso": "*" },
    { "id": 643, "nombre": "RUSIA FEDERACION DE", "iso2": "RU", "iso3": "", "iso": "" },
    { "id": 646, "nombre": "RUANDA", "iso2": "RW", "iso3": "", "iso": "" },
    { "id": 654, "nombre": "SANTA HELENA", "iso2": "SH", "iso3": "", "iso": "" },
    { "id": 659, "nombre": "SAN CRISTOBAL Y NIEVES", "iso2": "KN", "iso3": "", "iso": "" },
    { "id": 660, "nombre": "ANGUILA", "iso2": "AI", "iso3": "*", "iso": "" },
    { "id": 662, "nombre": "SANTA LUCIA", "iso2": "LC", "iso3": "*", "iso": "" },
    { "id": 666, "nombre": "SAN PEDRO Y MIQUELON", "iso2": "PM", "iso3": "", "iso": "" },
    { "id": 670, "nombre": "SAN VICENTE Y GRANADINAS", "iso2": "VC", "iso3": "*", "iso": "" },
    { "id": 674, "nombre": "SAN MARINO", "iso2": "SM", "iso3": "*", "iso": "" },
    { "id": 678, "nombre": "SANTO TOMAS Y PRINCIPE", "iso2": "ST", "iso3": "", "iso": "" },
    { "id": 682, "nombre": "ARABIA SAUDI", "iso2": "SA", "iso3": "", "iso": "" },
    { "id": 686, "nombre": "SENEGAL", "iso2": "SN", "iso3": "", "iso": "" },
    { "id": 688, "nombre": "SERBIA", "iso2": "RS", "iso3": "", "iso": "" },
    { "id": 690, "nombre": "SEYCHELLES", "iso2": "SC", "iso3": "*", "iso": "" },
    { "id": 694, "nombre": "SIERRA LEONA", "iso2": "SL", "iso3": "", "iso": "" },
    { "id": 702, "nombre": "SINGAPUR", "iso2": "SG", "iso3": "*", "iso": "" },
    { "id": 703, "nombre": "REPUBLICA ESLOVACA", "iso2": "SK", "iso3": "", "iso": "*" },
    { "id": 704, "nombre": "VIETNAM", "iso2": "VN", "iso3": "", "iso": "" },
    { "id": 705, "nombre": "ESLOVENIA", "iso2": "SI", "iso3": "", "iso": "*" },
    { "id": 706, "nombre": "SOMALIA", "iso2": "SO", "iso3": "", "iso": "" },
    { "id": 710, "nombre": "SUDAFRICA", "iso2": "ZA", "iso3": "", "iso": "" },
    { "id": 716, "nombre": "ZIMBABWE", "iso2": "ZW", "iso3": "", "iso": "" },
    { "id": 724, "nombre": "ESPAÑA", "iso2": "ES", "iso3": "", "iso": "" },
    { "id": 732, "nombre": "SAHARA OCCIDENTAL", "iso2": "**", "iso3": "", "iso": "" },
    { "id": 736, "nombre": "SUDAN", "iso2": "SD", "iso3": "", "iso": "" },
    { "id": 740, "nombre": "SURINAM", "iso2": "SR", "iso3": "", "iso": "" },
    { "id": 744, "nombre": "SVALBARD E ISLA JUAN MAYEN", "iso2": "**", "iso3": "", "iso": "" },
    { "id": 748, "nombre": "SWAZILANDIA", "iso2": "SZ", "iso3": "", "iso": "" },
    { "id": 752, "nombre": "SUECIA", "iso2": "SE", "iso3": "", "iso": "*" },
    { "id": 756, "nombre": "SUIZA", "iso2": "CH", "iso3": "", "iso": "" },
    { "id": 760, "nombre": "SIRIA REPUBLICA ARABE", "iso2": "SY", "iso3": "", "iso": "" },
    { "id": 762, "nombre": "TADJIKISTAN", "iso2": "**", "iso3": "", "iso": "" },
    { "id": 764, "nombre": "TAILANDIA", "iso2": "TH", "iso3": "", "iso": "" },
    { "id": 768, "nombre": "TOGO", "iso2": "TG", "iso3": "", "iso": "" },
    { "id": 772, "nombre": "TOKELAU", "iso2": "TK", "iso3": "", "iso": "" },
    { "id": 776, "nombre": "TONGA", "iso2": "TO", "iso3": "", "iso": "" },
    { "id": 780, "nombre": "TRINIDAD Y TOBAGO", "iso2": "TT", "iso3": "*", "iso": "" },
    { "id": 784, "nombre": "EMIRATOS ARABES UNIDOS", "iso2": "AE", "iso3": "*", "iso": "" },
    { "id": 788, "nombre": "TUNEZ", "iso2": "TN", "iso3": "", "iso": "" },
    { "id": 792, "nombre": "TURQUIA", "iso2": "TR", "iso3": "", "iso": "" },
    { "id": 795, "nombre": "TURQUESTAN", "iso2": "**", "iso3": "", "iso": "" },
    { "id": 796, "nombre": "TURKS Y CAICOS ISLAS", "iso2": "TC", "iso3": "*", "iso": "" },
    { "id": 798, "nombre": "TUVALU", "iso2": "TV", "iso3": "", "iso": "" },
    { "id": 800, "nombre": "UGANDA", "iso2": "UG", "iso3": "", "iso": "" },
    { "id": 804, "nombre": "UCRANIA", "iso2": "UA", "iso3": "", "iso": "" },
    { "id": 807, "nombre": "MACEDONIA", "iso2": "MK", "iso3": "", "iso": "" },
    { "id": 818, "nombre": "EGIPTO", "iso2": "EG", "iso3": "", "iso": "" },
    { "id": 826, "nombre": "GRAN BRETAÑA", "iso2": "GB", "iso3": "", "iso": "*" },
    { "id": 834, "nombre": "TANZANIA REPUBLICA UNIDA DE", "iso2": "TZ", "iso3": "", "iso": "" },
    { "id": 840, "nombre": "ESTADOS UNIDOS", "iso2": "US", "iso3": "", "iso": "" },
    { "id": 850, "nombre": "VIRGENES (USA) ISLAS", "iso2": "VI", "iso3": "*", "iso": "" },
    { "id": 854, "nombre": "BURKINA FASO", "iso2": "BF", "iso3": "", "iso": "" },
    { "id": 858, "nombre": "URUGUAY", "iso2": "UY", "iso3": "", "iso": "" },
    { "id": 860, "nombre": "UZBEKISTAN", "iso2": "UZ", "iso3": "", "iso": "" },
    { "id": 862, "nombre": "VENEZUELA", "iso2": "VE", "iso3": "", "iso": "" },
    { "id": 876, "nombre": "WALLIS Y FUTUNA", "iso2": "WF", "iso3": "", "iso": "" },
    { "id": 882, "nombre": "SAMOA", "iso2": "WS", "iso3": "", "iso": "" },
    { "id": 887, "nombre": "YEMEN", "iso2": "YE", "iso3": "", "iso": "" },
    { "id": 891, "nombre": "YUGOSLAVIA", "iso2": "**", "iso3": "", "iso": "" },
    { "id": 894, "nombre": "ZAMBIA", "iso2": "ZM", "iso3": "", "iso": "" },
    { "id": 952, "nombre": "APATRIDA", "iso2": "**", "iso3": "", "iso": "" },
    { "id": 953, "nombre": "PAIS DESCONOCIDO", "iso2": "**", "iso3": "", "iso": "" },
    { "id": 954, "nombre": "DESCONOCIDO SIN CONVENIO", "iso2": "**", "iso3": "", "iso": "" },
    { "id": 955, "nombre": "DESCONOCIDO CON CONVENIO", "iso2": "**", "iso3": "", "iso": "" },
    { "id": 956, "nombre": "TERR.ANT.REP.YUGOSLAVA DE MACE", "iso2": "**", "iso3": "", "iso": "" },
    { "id": 957, "nombre": "SUDAN DEL SUR", "iso2": "SS", "iso3": "", "iso": "" },
    { "id": 958, "nombre": "CURACAO", "iso2": "CW", "iso3": "", "iso": "" },
    { "id": 959, "nombre": "SAN MARTIN", "iso2": "SX", "iso3": "", "iso": "" },
    { "id": 960, "nombre": "BONAIRE, SAN EUSTAQUIO Y SABA", "iso2": "BQ", "iso3": "", "iso": "" },
    { "id": 961, "nombre": "GRECIA", "iso2": "GR", "iso3": "", "iso": "*" }
].sort((n1, n2) => {
    if (n1.nombre > n2.nombre) {
    return 1;
    }

    if (n1.nombre < n2.nombre) {
    return -1;
    }

    return 0;
});

